import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getClientPrice = createAsyncThunk(
  "clientPrice/getClientPrice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/clientPrice/getClientPrice", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const createClientPrice = createAsyncThunk(
  "clientPrice/clientprice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/clientPrice/clientprice", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateClientPrice = createAsyncThunk(
  "clientPrice/updateClientPrice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/clientPrice/updateClientPrice", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getClientPriceById = createAsyncThunk(
  "clientPrice/getClientPriceById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/clientPrice/getClientPriceById",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  loading: false,
  clientPrice: [],
  clientPriceById: [],
  isLoading: false,
  error: null,
  searchMessage: null,
  successMessage: null,
  errorMessage: null,
  createclientPriceSuccessMessage: null,
  createclientPriceErrorMessage: null,
  updateClientPriceSuccessMessage: null,
  updateClientPriceErrorMessage: null,
  // pagination fields
  currentPage: 1,
  totalPages: 1,
  totalCount: 0,
  hasMore: true,
};

const clientPriceSlice = createSlice({
  name: "clientPrice",
  initialState,
  reducers: {
    resetCreateMessages: (state) => {
      state.createclientPriceSuccessMessage = null;
      state.createclientPriceErrorMessage = null;
    },
    resetUpdateMessages: (state) => {
      state.updateClientPriceSuccessMessage = null;
      state.updateClientPriceErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getClientPrice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getClientPrice.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload?.success) {
          state.clientPrice = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.currentPage = 1;
          state.hasMore = false;
          state.searchMessage = action.payload?.result?.message || "No data found";
          return;
        }
        const result = action.payload.result || {};
        state.clientPrice = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchMessage = null;
      })
      .addCase(getClientPrice.rejected, (state, action) => {
        state.loading = false;
        state.searchMessage =
          action?.payload?.result?.message || action?.payload || action?.error?.message;
      })
      .addCase(createClientPrice.pending, (state) => {
        state.loading = true;
      })
      .addCase(createClientPrice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === true) {
          state.createclientPriceSuccessMessage = action?.payload?.result?.message;
        } else {
          state.createclientPriceErrorMessage = action?.payload?.result?.message;
        }
      })
      .addCase(createClientPrice.rejected, (state, action) => {
        state.loading = false;
        state.createclientPriceErrorMessage = action?.payload?.result?.message;
      })
      .addCase(updateClientPrice.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateClientPrice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === true) {
          state.updateClientPriceSuccessMessage = action?.payload?.result?.message;
        } else {
          state.updateClientPriceErrorMessage = action?.payload?.result?.message;
        }
      })
      .addCase(updateClientPrice.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getClientPriceById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getClientPriceById.fulfilled, (state, action) => {
        state.loading = false;
        state.clientPriceById = action?.payload?.result?.list;
      })
      .addCase(getClientPriceById.rejected, (state, action) => {
        state.getByIdLoading = false;
      });
  },
});
export const { resetCreateMessages, resetUpdateMessages } =
  clientPriceSlice.actions;

export default clientPriceSlice.reducer;